module.exports = __webpack_public_path__ + "static/media/Mission_SV.bf51f9ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mission_SV.png
// module id = 1059
// module chunks = 0